import { useRef, useState } from "react";
import { apiError } from "@/lib/api";
import { fileUrl, uploadSiteImage } from "@/lib/site";
import { Button } from "@/components/ui/button";
import { ImageSquare, CircleNotch, X } from "@phosphor-icons/react";
import { toast } from "sonner";

export function ImageUpload({ value, onChange, testid, aspect = "aspect-square", label = "Carregar imagem", uploader = uploadSiteImage }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try {
      onChange(await uploader(f));
    } catch (err) {
      toast.error(apiError(err, "Falha ao carregar a imagem"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`relative overflow-hidden rounded-xl border border-dashed border-border bg-muted ${aspect}`} data-testid={testid}>
      {value ? (
        <img src={fileUrl(value)} alt="" className="h-full w-full object-cover" />
      ) : (
        <button type="button" onClick={() => ref.current?.click()} disabled={busy}
          className="flex h-full w-full flex-col items-center justify-center gap-1 text-xs text-muted-foreground hover:bg-accent"
          data-testid={`${testid}-pick`}>
          {busy ? <CircleNotch size={22} className="animate-spin" /> : <ImageSquare size={24} />}
          {label}
        </button>
      )}
      {value && (
        <div className="absolute right-1.5 top-1.5 flex gap-1">
          <Button type="button" size="sm" variant="secondary" className="h-7 px-2 text-xs" onClick={() => ref.current?.click()}
            data-testid={`${testid}-change`}>{busy ? <CircleNotch className="animate-spin" /> : "Trocar"}</Button>
          <Button type="button" size="icon" variant="secondary" className="h-7 w-7" onClick={() => onChange(null)}
            data-testid={`${testid}-remove`}><X size={14} /></Button>
        </div>
      )}
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={pick} />
    </div>
  );
}
